import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SignUpComponent } from '../sign-up/sign-up.component';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { environment } from '../../../../environments/environment';
import { BehaviourService } from '../../../shared/services/behaviour.service';
import { DexieDbService } from 'src/app/shared/services/dexie-db.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { createConfig } from 'src/app/utils/default-configs/configuration';
// import { allConfigIds } from 'src/app/utils/constants/constant';
import { concatMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { allconfig } from 'src/app/utils/constants/constant';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, OnChanges {
  @Input() isLoggedIn: any;
  @ViewChild('hiddenLink') hiddenLink: ElementRef;
  environmentConfig = environment;
  searchTermCustomers: string = '';
  navbarList: string[] = ['Configuration', 'Shipment', 'Invoice', 'system'];
  options = ['Logout'];
  position = new FormControl(this.options[0]);
  bbxuserID;
  bbxuserActive: any;
  bbxcustomerID: any;
  bbxusertoken: any;
  bbxuserrole: any;
  bbxlogout = false;
  datareceived: any;
  Roles: any;
  customerIDs: any;
  filterSearchCustomerIds = [];
  selectedRole: any;
  selectedCustomerID: any;
  config: any = {};
  profileUrl;

  constructor(
    private dialog: MatDialog,
    private behaviourService: BehaviourService,
    private router: Router,
    private authService: AuthService,
    private dexieDbService: DexieDbService,
    private configService: ConfigService,
    private translate: TranslateService
  ) {
    this.bbxuserID = sessionStorage.getItem('bbx-userID');
    this.authService.data.subscribe(response => {
      this.datareceived = response;
    });
    const ALLOWED_PATHS = [
      'https://stg.dhlpass.dhl.com/auth/oidc/profile',
      'https://uat.dhlpass.dhl.com/auth/oidc/profile',
      'https://dhlpass.dhl.com/auth/oidc/profile',
    ];
    const authUrl = environment.authUrl;
    const passClientId = /^[A-Za-z-]+$/.test(environment.passClientId)
      ? environment.passClientId
      : '';
    const userCountry = /^[A-Za-z-]+$/.test(this.authService.getUserCountry())
      ? this.authService.getUserCountry()
      : '';
    const parsedUrl = `${authUrl}/profile?client_id=${passClientId}&LangCode=en&CountryCode=${userCountry}`;
    const containsSubstring = ALLOWED_PATHS.some(item => item.includes(parsedUrl.split('?')[0]));
    if (containsSubstring) {
      this.profileUrl = parsedUrl;
    } else {
      this.profileUrl = '';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // tslint:disable-next-line:no-unused-expression
    if (changes?.isLoggedIn?.currentValue === 'true') {
      this.getUserInformationOnRender().then();
    }
    //  changes?.isLoggedIn?.currentValue === 'true' && this.getUserInformationOnRender().then();
  }

  ngOnInit() {
    this.getUserInformationOnRender().then();
  }

  switchLanguage(language: string) {
    this.translate.use(language);
    localStorage.setItem('locale', language);
  }

  async getUserInformationOnRender() {
    this.bbxuserActive = sessionStorage.getItem('bbx-active');
    this.bbxcustomerID = sessionStorage.getItem('bbx-customerID');
    this.bbxuserrole = sessionStorage.getItem('bbx-role');
    this.selectedRole = sessionStorage.getItem('bbx-role');
    this.selectedCustomerID = sessionStorage.getItem('bbx-customerID');
    this.authService.sendData(sessionStorage.getItem('isLoggedIn'));
    this.Roles = JSON.parse(sessionStorage.getItem('bbx-rolesarray'));
    this.authService.getCustomersByRole().subscribe(res => {
      this.customerIDs = this.filterSearchCustomerIds = res.map(customer => customer.customerID);
    });

    this.config = {
      displayKey: 'Roles',
      search: true,
      height: 'auto',
      placeholder: this.Roles && this.Roles[0],
      limitTo: this.Roles && this.Roles.length,
      moreText: 'item',
      noResultsFound: 'No results found',
      searchPlaceholder: 'Search',
      searchOnKey: 'Roles',
    };
  }

  filterBySearch(searchTerm) {
    if (searchTerm && searchTerm.trim() !== '') {
      this.customerIDs = this.filterSearchCustomerIds.filter(
        item => item.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    } else {
      this.customerIDs = this.filterSearchCustomerIds;
    }
  }

  changeRole() {
    sessionStorage.setItem('bbx-role', this.selectedRole);
    //TODO: If admin changing customer directly in specification page there is bug need to make configuration in specification
    this.behaviourService.sendEvent(sessionStorage.getItem('isCustomInvoice'));
    this.getAllSetConfigs();
  }

  isUserCanViewCustomers() {
    if (this.selectedRole === 'COUNTRY_IT_ADMIN' || this.selectedRole === 'GLOBAL_ADMIN') {
      return true;
    } else {
      return false;
    }
  }

  changeCustomerID() {
    sessionStorage.setItem('bbx-customerID', this.selectedCustomerID);
    this.authService.getCustomersByCacheStatus(this.selectedCustomerID).subscribe(res => {
      sessionStorage.setItem('cacheActive', res.cacheActive);
      this.getAllSetConfigs();
    });
  }

  triggerEvent(event) {
    if (!event) {
      this.customerIDs = this.filterSearchCustomerIds;
      this.searchTermCustomers = '';
    }
    // !event && (this.customerIDs = this.filterSearchCustomerIds) && (this.searchTermCustomers = '');
  }

  openDialog() {
    this.dialog.open(SignUpComponent, {
      data: {
        message: this.translate.instant('alert.deleteSure'),
        buttonText: {
          ok: this.translate.instant('global.save'),
          cancel: this.translate.instant('global.no'),
        },
      },
    });
  }

  closeDialog() {
    const closed = sessionStorage.getItem('closedialog');
    if (closed === 'close') {
      this.dialog.closeAll();
    }
  }

  logoutUser() {
    this.authService.logoutUser().subscribe(() => {
      this.bbxuserID = '';
      sessionStorage.removeItem('bbx-userID');
      sessionStorage.clear();
      this.router.navigateByUrl('/login');
      this.dexieDbService.clearTable();
    });
  }

  get isLoggedInUser() {
    this.bbxuserID = sessionStorage.getItem('bbx-userID');
    this.selectedRole = sessionStorage.getItem('bbx-role');
    this.selectedCustomerID = sessionStorage.getItem('bbx-customerID');
    return sessionStorage.getItem('isLoggedIn') === 'true';
  }

  usersList() {
    this.router.navigateByUrl('/users-list');
  }

  navChangePassword() {
    this.router.navigateByUrl('/change-password');
  }

  getAllSetConfigs() {
    this.dexieDbService.clearTable();
    this.configService
      .getConfig(createConfig(allconfig))
      .pipe(
        concatMap(response => {
          // Process each item and return an observable
          const putConfigObservables = response.map(item => {
            if (Object.keys(item).length !== 0) {
              if (item.config_id) {
                return this.configService.putConfig(item.config_id, item.data);
              } else {
                console.log(item);
              }
            } else {
              // Return an observable that completes immediately for empty items
              return of(null);
            }
          });

          // Use forkJoin to wait for all putConfigObservables to complete
          return forkJoin(putConfigObservables);
        })
      )
      .subscribe(() => {
        this.configService.fetchConfig('loose_bbx').then(loosebbx => {
          sessionStorage.setItem('loose-bbx', loosebbx?.data?.[0]?.toString());
        });
        // All putConfig operations have completed here
        window.location.reload();
      });
  }
}
